import { useState, useEffect, useContext } from "react";
import { Formik, Form as FormikForm, ErrorMessage, Field } from "formik";
import { TextField, Select } from "@mui/material";
import { Form, Row, Col, Container, Modal } from "react-bootstrap";
import { UserDataContext } from "../components/UserDataContext";
import { TaskContext } from "../components/TaskContext";
import { registerLocale } from "react-datepicker";
import "../components/button.css";
import Alerts from "../components/Alerts";
import { marginBottom } from "../App";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { pl } from "date-fns/locale";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../components/theme";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import { useNavigate } from "react-router-dom";
import Card from "react-bootstrap/Card";
import { format } from "date-fns";
import { InputLabel } from "@mui/material";
import { apiRequest } from "../components/Config";

registerLocale("pl", pl);

export default function TaskContent() {
  const { taskId } = useContext(TaskContext);
  const { userData } = useContext(UserDataContext);
  const [content, setContent] = useState("");
  const [showApiResponse, setShowApiResponse] = useState(false);
  const [showReturnContent, setShowReturnContent] = useState(false);
  const [disabledEdit, setDisabledEdit] = useState("");
  const [apiResponse, setApiResponse] = useState({});
  const [buildingParts, setBuildingParts] = useState([]);
  const [typeoftasks, setTypeoftasks] = useState([]);
  const navigate = useNavigate();
  const [text, setText] = useState("");
  const [statusClass, setStatusClass] = useState();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [statusId, setStatusId] = useState();
  const [termDisabled, setTermDisabled] = useState(true);
  const [Values, setValues] = useState({});
  const [initialFormValues, setInitialFormValues] = useState({
    typeoftaskId: "",
    typeoftask: "",
    buildingpartId: "",
    buildingpart: "",
    reporter: "",
    reporterMail: "",
    reporterPhone: "",
    location: "",
    performer: "",
    performerName: "",
    content: "",
    selectedDate: "",
    selectedEndDate: "",
    statusId: "",
    status: "",
    receiveData: "",
    completionDate: "",
  });

  useEffect(() => {
    if (userData) {
      if (userData && userData.permId === "1") {
        setText(
          "Nie można edytować tego zlecenia ponieważ zostało przypisane Wykonawcy. W celu edycji wycofaj Zlecenie, które będzie miało status: Zarejestrowane."
        );
      }
      if (userData.permId === "2") {
        setText(
          "Jeżeli nie chcesz podjąć tego Zlecenia wycofaj je do Zleceniodawcy."
        );
      }
    }
    if (
      initialFormValues.statusId !== "8" &&
      initialFormValues.statusId !== "19" &&
      initialFormValues.statusId !== "20" &&
      userData &&
      (userData.permId === "1" || userData.permId === "3")
    ) {
      setTermDisabled(false);
    } else {
      setTermDisabled(true);
    }
  }, [userData, initialFormValues]);

  useEffect(() => {
    if (userData) {
      const fetchData = async () => {
        try {
          const response = await apiRequest("task", "POST", { id: taskId });
          if (Array.isArray(response) && response.length > 0) {
            setInitialFormValues({
              typeoftaskId: response[0].typeoftaskId || "",
              typeoftask: response[0].typeoftask || "",
              buildingpartId: response[0].buildingpartId || "",
              buildingpart: response[0].buildingpart || "",
              reporter: response[0].reporter || "",
              reporterMail: response[0].reporterMail || "",
              reporterPhone: response[0].reporterPhone || "",
              location: response[0].location || "",
              performerName: response[0].performerName || "brak",
              nettoPerformer: response[0].nettoPerformer || "",
              performer: response[0].performer || 0,
              content: response[0].content || "",
              receiv: response[0].receiveData || "",
              completionDate: response[0].completionDate || "",
              statusId: response[0].statusId || 0,
              status: response[0].status || "",
              selectedDate: response[0].receiveData
                ? new Date(response[0].receiveData)
                : null,
              selectedEndDate: response[0].completionDate
                ? new Date(response[0].completionDate)
                : null,
            });
            setStatusClass(response[0].class);
          } else {
            throw new Error("Nieprawidłowa odpowiedź z serwera");
          }
        } catch (error) {
          console.error("Błąd w pobieraniu danych:", error);
        }
      };

      fetchData();
    }
  }, [userData, taskId]);

  useEffect(() => {
    if (userData) {
      const fetchData = async () => {
        try {
          const response = await apiRequest("typeoftasks");
          setTypeoftasks(response);
        } catch (error) {
          console.error(error.message);
        }
      };
      fetchData();
    }
  }, [userData]);

  useEffect(() => {
    if (userData) {
      const fetchData = async () => {
        try {
          const response = await apiRequest("buildingparts");
          setBuildingParts(response);
        } catch (error) {
          console.error(error.message);
        }
      };
      fetchData();
    }
  }, [userData]);

  useEffect(() => {
    if (
      initialFormValues.statusId !== "1" &&
      initialFormValues.statusId !== "10" &&
      initialFormValues.statusId !== "12" &&
      initialFormValues.statusId !== "13"
    ) {
      setDisabledEdit("disabled");
    } else {
      setDisabledEdit("");
    }
  }, [initialFormValues]);

  const handleShowReturn = () => {
    setShowReturnContent(!showReturnContent);
  };

  const confirmChangeStatus = (sId) => {
    setShow(true);
    setStatusId(sId);
  };

  const handleStatusChange = async (statusId) => {
    //console.log("HSC: ", statusId);
    try {
      const response = await apiRequest("taskreturn", "POST", {
        taskId: taskId,
        content: content,
        performer: initialFormValues.performer,
        status: statusId,
      });
      //console.log("taskreturn: ", response);
    } catch (error) {
      console.error(error.message);
    }
    navigate("/tasks");
  };

  /*
      if (initialFormValues.nettoPerformer === "") {
      setShowApiResponse(true);
      setApiResponse({
        title: "Uwaga",
        severity: "error",
        info: "Nie można podjąć Zlecenia przed akceptacją wyceny. W celu akceptacji wyceny zlecenia skontaktuj się z Administratorem.",
      });
    }
*/
  return (
    <div>
      {showApiResponse && (
        <Row style={{ marginBottom }}>
          <Alerts data={apiResponse} />
        </Row>
      )}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Potwierdzenie</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {statusId === 4 ? (
            <>
              Potwierdzasz akceptację wykonania zlecenia <b>[{taskId}]</b> i
              jego terminu ?
            </>
          ) : null}
          {statusId === 5 ? (
            <>Potwierdzasz wykonanie zlecenia {taskId}?</>
          ) : null}
          {statusId === 7 ? <>Potwierdzasz reklamację zlecenia?</> : null}
          {statusId === 8 ? (
            <>
              Potwierdzasz odbiór zlecenia?
              <br /> Zlecenie zostanie zamknięte i nie będzie możliwości edycji.
            </>
          ) : null}
          {statusId === 19 ? (
            <>
              Potwierdzasz status FAKTURA ZAPŁACONA?
              <br /> Zlecenie zostanie przeniesione do archiwum.
            </>
          ) : null}
          <br />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outlined" onClick={handleClose}>
            Anuluj
          </Button>
          <Button
            variant="contained"
            onClick={() => handleStatusChange(statusId)}
          >
            Potwierdź
          </Button>
        </Modal.Footer>
      </Modal>

      <hr></hr>
      <Container>
        {initialFormValues.statusId === "2" && (
          <>
            <Col md="12">
              <p className="p5">{text}</p>
              <Card.Link href="#" onClick={handleShowReturn}>
                Wycofaj Zlecenie
              </Card.Link>
            </Col>

            <Col md="6">
              {showReturnContent && (
                <>
                  <TextField
                    id="outlined-basic"
                    name="content"
                    label="Powód wycofania Zlecenia"
                    variant="outlined"
                    fullWidth
                    multiline
                    minRows={3}
                    onChange={(e) => setContent(e.target.value)}
                    style={{ marginBottom: "20px" }}
                    value={content}
                  />

                  <Button
                    variant="outlined"
                    onClick={() => handleStatusChange(1)}
                  >
                    Wycofaj
                  </Button>
                </>
              )}
            </Col>
          </>
        )}
        <Col>
          {userData &&
            userData.permId === "2" &&
            initialFormValues.statusId === "3" && (
              <Button variant="outlined" onClick={() => confirmChangeStatus(4)}>
                Akceptacja zlecenia i terminu wykonania
              </Button>
            )}
        </Col>
      </Container>

      {(initialFormValues.statusId === "4" ||
        initialFormValues.statusId === "7") &&
        userData &&
        userData.permId === "2" && (
          <Container>
            <Row>
              <Col>
                <Button
                  variant="outlined"
                  onClick={() => confirmChangeStatus(5)}
                >
                  Zgłoś zakończenie zadania
                </Button>
              </Col>
            </Row>
          </Container>
        )}
      {initialFormValues.statusId === "5" &&
        userData &&
        userData.permId === "1" && (
          <Container>
            <Row>
              <Col>
                <Button
                  variant="outlined"
                  onClick={() => confirmChangeStatus(8)}
                >
                  Odebrane bez uwag
                </Button>
              </Col>
              <Col>
                <Button
                  variant="outlined"
                  onClick={() => confirmChangeStatus(7)}
                >
                  Reklamacja zlecenia
                </Button>
              </Col>
            </Row>
          </Container>
        )}
      {initialFormValues.statusId === "8" &&
        userData &&
        (userData.permId === "1" || userData.permId === "3") && (
          <Container>
            <Row>
              <Col>
                <Button
                  variant="outlined"
                  onClick={() => confirmChangeStatus(19)}
                >
                  Faktura opłacona
                </Button>
              </Col>
            </Row>
          </Container>
        )}
      <hr></hr>
      <ThemeProvider theme={theme}>
        <Container>
          <Formik
            initialValues={{
              ...initialFormValues,
              selectedDate: initialFormValues.selectedDate
                ? new Date(initialFormValues.selectedDate)
                : null,
              selectedEndDate: initialFormValues.selectedEndDate
                ? new Date(initialFormValues.selectedEndDate)
                : null,
            }}
            enableReinitialize={true}
            onSubmit={async (values, { setSubmitting }) => {
              const formatted = format(values.selectedDate, "yyyy-MM-dd");

              const completionFormatted = format(
                values.selectedEndDate,
                "yyyy-MM-dd"
              );

              values["receiveData"] = formatted;
              values["completionDate"] = completionFormatted;
              values["taskId"] = taskId;
              delete values.performer;
              delete values.performerName;
              setValues(values);
              try {
                const response = await apiRequest("updatetask", "POST", values);
                if (response.error_msg === 200) {
                  setShowApiResponse(true);
                  setApiResponse({
                    title: "Informacja",
                    severity: "success",
                    info: "Dane zaktualizowane!",
                  });
                }
                if (response.error_msg === 559) {
                  setShowApiResponse(true);
                  setApiResponse({
                    title: "Uwaga",
                    severity: "error",
                    info: "Dane nie zostały zaktualizowane.",
                  });
                }
                if (response.error_msg === 500) {
                  setShowApiResponse(true);
                  setApiResponse({
                    title: "Uwaga",
                    severity: "error",
                    info: "Dane nie zostały zaktualizowane.",
                  });
                }
              } catch (error) {
                setShowApiResponse(true);
                setApiResponse({
                  title: "Uwaga",
                  severity: "error",
                  info: "Nie udało się zaktualizować!",
                });
                console.error("There was an error editing the user!", error);
              } finally {
                setSubmitting(false);
              }
            }}
          >
            {({ values, handleSubmit, isSubmitting, setFieldValue }) => (
              <FormikForm onSubmit={handleSubmit}>
                <Row style={{ marginBottom }}>
                  <Col md="4">
                    <Form.Group controlId="formTypeOfTask">
                      <InputLabel id="typeoftask-label">
                        Źródło Zlecenia
                      </InputLabel>
                      <Select
                        id="typeoftask"
                        name="typeoftask"
                        value={values.typeoftaskId}
                        onChange={(e) => {
                          const selectedId = parseInt(e.target.value, 10);
                          const selectedType =
                            typeoftasks.find((type) => type.id === selectedId)
                              ?.typeoftask || "";

                          setFieldValue("typeoftaskId", selectedId);
                          setFieldValue("typeoftask", selectedType);
                        }}
                        fullWidth
                        disabled={disabledEdit === "disabled"}
                      >
                        {typeoftasks.map((type) => (
                          <MenuItem key={type.id} value={type.id}>
                            {type.typeoftask}
                          </MenuItem>
                        ))}
                      </Select>
                    </Form.Group>
                  </Col>
                  <Col md="4">
                    <Form.Group controlId="formBuildingPart">
                      <InputLabel>Czego dotyczy zlecenie:</InputLabel>
                      <Select
                        id="buildingPart"
                        name="buildingPart"
                        value={values.buildingpartId}
                        label="Zlecenie"
                        onChange={(e) => {
                          const selectedId = parseInt(e.target.value, 10);
                          const selectedType =
                            buildingParts.find((type) => type.id === selectedId)
                              ?.buildingpart || "";

                          setFieldValue("buildingpartId", selectedId);
                          setFieldValue("buildingpart", selectedType);
                        }}
                        fullWidth
                        disabled={disabledEdit === "disabled"}
                      >
                        {buildingParts.map((part) => (
                          <MenuItem key={part.id} value={part.id}>
                            {part.buildingpart}
                          </MenuItem>
                        ))}
                      </Select>
                    </Form.Group>
                  </Col>
                  <Col md="4">
                    <Form.Group controlId="formLocation">
                      <InputLabel id="location-label">
                        Lokalizacja obiektu
                      </InputLabel>
                      <Field
                        as={TextField}
                        type="text"
                        id="location"
                        name="location"
                        fullWidth
                        variant="outlined"
                        value={values.location}
                        onChange={(e) =>
                          setFieldValue("location", e.target.value)
                        }
                        disabled={disabledEdit === "disabled"}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row style={{ marginBottom }}>
                  <Col md="4">
                    <Form.Group controlId="formReporter">
                      <InputLabel id="reporter-label">Zleceniodawca</InputLabel>
                      <Field
                        as={TextField}
                        type="text"
                        id="reporter"
                        name="reporter"
                        fullWidth
                        variant="outlined"
                        value={values.reporter}
                        onChange={(e) =>
                          setFieldValue("reporter", e.target.value)
                        }
                        disabled={disabledEdit === "disabled"}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="4">
                    <Form.Group controlId="formReporter">
                      <InputLabel id="reporter-mail">
                        Mail zleceniodawcy
                      </InputLabel>
                      <Field
                        as={TextField}
                        type="text"
                        id="reporterMail"
                        name="reporterMail"
                        fullWidth
                        variant="outlined"
                        value={values.reporterMail}
                        onChange={(e) =>
                          setFieldValue("reporterMail", e.target.value)
                        }
                        disabled={disabledEdit === "disabled"}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="4">
                    <Form.Group controlId="formReporter">
                      <InputLabel id="reporter-phone">
                        Telefon zleceniodawcy
                      </InputLabel>
                      <Field
                        as={TextField}
                        type="text"
                        id="reporterPhone"
                        name="reporterPhone"
                        fullWidth
                        variant="outlined"
                        value={values.reporterPhone}
                        onChange={(e) =>
                          setFieldValue("reporterPhone", e.target.value)
                        }
                        disabled={disabledEdit === "disabled"}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row style={{ marginBottom }}>
                  <Col md="4">
                    <InputLabel id="content-label">Treść Zlecenia</InputLabel>
                    <Form.Group controlId="formContent">
                      <Field
                        as={TextField}
                        type="text"
                        name="content"
                        fullWidth
                        multiline
                        minRows={3}
                        variant="outlined"
                        value={values.content}
                        disabled={disabledEdit === "disabled"}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="4">
                    <Form.Group controlId="formDate">
                      <InputLabel>Data rejestracji Zlecenia</InputLabel>
                      <LocalizationProvider
                        dateAdapter={AdapterDateFns}
                        adapterLocale={pl}
                      >
                        <DatePicker
                          value={values.selectedDate}
                          onChange={(date) =>
                            setFieldValue("selectedDate", date)
                          }
                          format="yyyy-MM-dd"
                          slotProps={{
                            textField: { variant: "outlined" },
                          }}
                          disabled={disabledEdit === "disabled"}
                        />
                      </LocalizationProvider>
                    </Form.Group>
                  </Col>
                  <Col md="4">
                    <Form.Group controlId="formDateEnd">
                      <InputLabel>Termin realizacji</InputLabel>
                      <LocalizationProvider
                        dateAdapter={AdapterDateFns}
                        adapterLocale={pl}
                      >
                        <DatePicker
                          value={values.selectedEndDate}
                          onChange={(date) =>
                            setFieldValue("selectedEndDate", date)
                          }
                          format="yyyy-MM-dd"
                          slotProps={{
                            textField: { variant: "outlined" },
                          }}
                          disabled={termDisabled}
                        />
                      </LocalizationProvider>
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="align-items-start" style={{ marginBottom }}>
                  <Col>
                    {userData &&
                      initialFormValues.statusId !== "8" &&
                      userData.permId !== "2" && (
                        <Button
                          variant="contained"
                          type="submit"
                          disabled={isSubmitting}
                        >
                          Zapisz
                        </Button>
                      )}
                  </Col>
                </Row>
              </FormikForm>
            )}
          </Formik>

          {/* <FilesData uuid={id} /> */}
        </Container>
      </ThemeProvider>
    </div>
  );
}
